import React from 'react';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import KeywordTopicSelectionViewRow from './KeywordTopicSelectionViewRow';

export default class KeywordTopicSelectionView extends React.Component {
  render() {
    const {matchAny, newContext, defaultText} = this.props;
    return (
      <div className="rule-option-list rule-context-view">
        <ul>
          {matchAny &&
            matchAny.map((context, i) => (
              <li key={i}>
                <KeywordTopicSelectionViewRow
                  context={context}
                  label={i > 0 ? 'or ' : ''}
                  updateContext={newContext => this.props.updateItem(i, newContext)}
                />
                {i === matchAny.size - 1 && (
                  <div className="or-button" onClick={this.props.orClick}>
                    or
                  </div>
                )}
                <div className="delete" onClick={() => this.props.removeItem(i)}>
                  <CloseIcon />
                </div>
              </li>
            ))}
          {newContext != null && (
            <li>
              <KeywordTopicSelectionViewRow
                context={newContext}
                defaultText={defaultText}
                label={matchAny && matchAny.size > 0 ? 'or ' : ''}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}
